import React, { useState, useEffect } from 'react'
import axios from 'axios';

function Routerboard(){
    const [daftar, setDaftar]= useState([]);
    const fetchData = async () =>{
        //axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        await axios.get('http://localhost/backend-billing/api/getallrouter')
        .then((response)=>{
            setDaftar(response.data)
        })
    };
    useEffect(() => {
        fetchData();
    },[]);
    return(
        <div className='container'>
            <div className='row'>
                <div className='col-md-12'>
                    <ul>
                    {
                        daftar.map(daft=>(
                            <li>{daft.username}</li>
                        ))
                    }
                    </ul>
                </div>
            </div>
        </div>
    )
}
export default Routerboard;